import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";
import demologo from "../../assets/demologo.png";
import success from "../../assets/bookdemo/ezgif.com-gif-maker.gif";
import calender from "../../assets/bookdemo/Calender.png";
import time from "../../assets/bookdemo/filing time.png";
import moment from "moment";
import {
  slotFormatAMPM,
  overlapUTCtimeConverter,
  formatTimeslot,
} from "../../helpers/TimeDate";

const Success = () => {
  const { search } = useLocation();
  const planType = new URLSearchParams(search).get("type");
  console.log(planType);
  const planSubscribed = JSON.parse(localStorage.getItem("planSubscribed"));
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  //   const demoTime = JSON.parse(localStorage.getItem("DEMO_TIME"));
  //   const demoDate = JSON.parse(localStorage.getItem("DEMO_DATE"));
  //   const subject = JSON.parse(localStorage.getItem("SUBJECT"));
  const history = useHistory();

  //   const dateformat = moment(demoDate).format("ddd Do, MMMM  ")

  const User = JSON.parse(localStorage.getItem("USER"));
  //   localStorage.setItem("USER", JSON.stringify(demoUser));
  console.log(User._id);

  const goToDashboard = () => {
    if (planType === "kids") {
      localStorage.clear();
      window.open(
        `https://kids-testing.netlify.app/learner/dashboard?id=${User._id}`,
        "_self"
      );
    } else if (planType === "IELTS") {
      localStorage.clear();
      window.open(
        `https://ielts-testing-clapingo.netlify.app/learner/dashboard?id=${User._id}`,
        "_self"
      );
    } else {
      localStorage.removeItem("DEMO_SESSION");
      localStorage.removeItem("DEMO_TIME");
      localStorage.removeItem("DEMOUSER");
      localStorage.removeItem("DEMO_DATE");
      localStorage.removeItem("DEMO_DATE");
      history.push("/dashboard");
    }
  };

  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">
          <div className="steps">
            <div className="steps-flex">
              <p
                className="step1"
                style={{ fontWeight: "bolder", color: "#24A15C" }}
              >
                STEP-1
              </p>
              <p
                className="step2"
                style={{ fontWeight: "bolder", color: "#24A15C" }}
              >
                STEP-2
              </p>
              <p
                className="step3"
                style={{ fontWeight: "bolder", color: "#24A15C" }}
              >
                STEP-3
              </p>
            </div>
            <ProgressBar
              percent={100}
              filledBackground="linear-gradient(to right, #24A15C, #44E18C)"
            />
          </div>
          <div className="demo-success">
            <div className="mb-2 mt-3">
              <img
                width="122px"
                height="32px"
                src={demologo}
                alt="clapingologo"
              />
            </div>
            <p className="headingfont">Congratulations!</p>
            <p className="subtitle">Subscription Booked.</p>
            <img src={success} className="success-img" alt="demo booked" />
            <div className="demo-details mt-4">
              <strong>
                {/* <strong>{"15 min."}</strong> Trial Details  */}
                Trial Details :
              </strong>
              <hr/><br/>
              <p>
                <strong>'{planSubscribed.subsName}'</strong><br/> has been activated for <strong>{planSubscribed.month}</strong> months.
                <br/>
                <br />
                Amount paid : {time_zone.country === "IN" && "₹"} <small>{planSubscribed.amount}</small>
              </p>
              {/* <div className="d-flex">
                <img
                  src={calender}
                  width={24}
                  height={24}
                  className="img-fluid"
                  alt="calender-img"
                />
                <p className="my-auto ml-3">{dateformat}</p>
              </div>
              <div className="d-flex mt-3">
                <img
                  src={time}
                  width={24}
                  height={24}
                  className="img-fluid"
                  alt="calender-img"
                />
                <p className="my-auto ml-3">{slotFormatAMPM(`${overlapUTCtimeConverter(demoTime.startTime)} - ${overlapUTCtimeConverter(demoTime.endTime)}`)}</p>
              </div> */}
            </div>
            <div className="instruction mt-4">
              <p>Instructions:</p>
              <ol>
                <li>You will receive joining details over whatsapp/email.</li>
                <li>Please make sure you have stable internet connection.</li>
                <li>
                  Please join the session on time. We ensure you a great
                  experience.
                </li>
              </ol>
            </div>

            <button
              type="submit"
              className="continueBTN  btn-block mx-auto"
              onClick={() => goToDashboard()}
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
